<template>
    <EmptyModalBase @close="$emit('close')">
        <div class="p-4">
            <div class="text-lg border-b border-gray-400">{{ $t('component.coronaInfo.dialog.title') }}</div>
            <div class="mt-4 text-sm">{{ $t('component.coronaInfo.dialog.section1') }}</div>

            <object class="mt-2" height="650" width="100%" type="application/pdf" :data="pdf">
                <p class="text-red-600">PDF cannot be displayed.</p>
            </object>

            <div class="mt-2 text-sm">{{ $t('component.coronaInfo.dialog.section2') }}</div>
            <div class="mt-2 text-sm">{{ $t('component.coronaInfo.dialog.section3') }}</div>
            <div class="mt-2 text-sm">{{ $t('component.coronaInfo.dialog.section4') }}</div>

            <div class="flex justify-end border-t mt-2 pt-4">
                <button @click="$emit('close')" class="border rounded py-2 px-4 cursor-pointer">{{ $t('component.coronaInfo.dialog.close') }}</button>
            </div>
        </div>
    </EmptyModalBase>
</template>

<script>
    import EmptyModalBase from "@/components/shared/EmptyModalBase";
    import coronaPlakatPdf from '@/../public/PLAKAT-OGO_LNY.pdf';
    export default {
        name: "CoronaModal",
        components: {EmptyModalBase},
        data() {
            return {
                pdf: coronaPlakatPdf
            }
        },
        mounted() {
            this.$ga.page('/corona');
        }
    }
</script>

<style scoped>

</style>